import CommentHeader from '~/pages/posts/CommentHeader'
import { CommentBody } from '~/pages/posts/CommentBody'
import React, { useRef } from 'react'
import '@css/pages/posts/CommentRow.scss'

export const CommentRow = ({
  commentId,
  handleDelete,
  onClickEdit,
  isOnSinglePost,
  isVeevanDiscussion,
  scrollToComment,
  postId,
  postHidden,
  lastLoadedComment,
  setLastLoadedComment,
  isHidden,
  isCustomerActivity,
}: {
  commentId: string
  handleDelete: (id: string) => void
  onClickEdit: () => void
  isOnSinglePost?: boolean
  isVeevanDiscussion?: boolean
  scrollToComment?: boolean
  postId: string
  postHidden: boolean
  lastLoadedComment?: string
  setLastLoadedComment?: (s: string) => void
  isHidden: boolean
  isCustomerActivity?: boolean
}) => {
  const headerRef = useRef<HTMLDivElement>(null)
  const hidden = isHidden || postHidden
  return (
    <div ref={headerRef} className={`comment-item ${isHidden ? 'hidden' : ''}`}>
      <CommentHeader
        commentId={commentId}
        onDelete={handleDelete}
        onClickEdit={onClickEdit}
        isOnSinglePost={isOnSinglePost}
        isVeevanDiscussion={isVeevanDiscussion}
        hidden={hidden}
        isCustomerActivity={isCustomerActivity}
      />
      <CommentBody
        postId={postId}
        commentId={commentId}
        scrollToComment={scrollToComment}
        headerRef={headerRef}
        hidden={hidden}
        lastLoadedComment={lastLoadedComment}
        setLastLoadedComment={setLastLoadedComment}
      />
    </div>
  )
}
